<template>
    <div class="assignment-header">
        <div class="left-side">
            <div
                class="component-title"
                v-if="viewType === 2">
                <h4 class="title">
                    {{ getPageTitle }}
                </h4>
            </div>
        </div>

        <div class="right-side">
            <b-badge
                class="badge-rating"
                v-if="hasRatingResult"
                :variant="'primary'"
                pill>
                <i class="fas fa-fw fa-trophy"></i>{{ subAssignmentIn.portfolio_rating.getValue() }}
            </b-badge>

            <b-button
                class="btn-comment-exclamation btn-show-sub-assignment-feedback-history"
                v-if="showFeedback"
                v-b-modal="'sub-assignment-feedback-details-modal'"
                v-b-tooltip.hover
                title="Feedback"
                variant="warning-icon">
            </b-button>

            <b-button
                class="btn-redo btn-primary"
                v-if="
                    $authUser.isStudent() &&
                    subAssignmentIn.statuses[0] &&
                    subAssignmentIn.statuses[0].status === 0 &&
                    subAssignmentIn.statuses[0].finished
                "
                v-b-tooltip.hover
                title="Deelopdracht heropenen"
                variant="primary-icon"
                @click="onReopen">
            </b-button>

            <design-2021-assignment-show-sub-assignment-feedback-details-model-component
                v-if="showFeedback"
                :sub-assignment-in="subAssignmentIn"
                :project-id="projectId">
            </design-2021-assignment-show-sub-assignment-feedback-details-model-component>

            <b-button
                class="btn-users btn-assignment-partner"
                v-b-modal="'sub-assignment-show-partner-modal-' + subAssignmentIn.id"
                v-b-tooltip.hover.top="'Samenwerken'"
                v-if="
                    subAssignmentIn.hasAssignmentCooperation() &&
                    (subAssignmentIn.assignment_cooperations[0].assignment_partners.length || !$authUser.isStudent())
                "
                variant="success-icon">
            </b-button>

            <b-dropdown
                class="ellipsis-nav sub-assignments-nav"
                v-if="!$authUser.isStudent()"
                no-caret
                right
                text="Right align"
                toggle-class="sub-assignments-context-menu"
                variant="primary">
                <template #button-content>
                    <i class="fas fa-ellipsis-v fa-fw"></i>
                </template>
                <b-dropdown-item
                    class="btn-approve-sub-assignment text-success"
                    v-if="canClose"
                    @click="onClose">
                    <i class="btn-checked"></i>{{ $t('group.approve_sub_assignment') }}
                </b-dropdown-item>
                <b-dropdown-item
                    class="btn-reopen-sub-assignment"
                    v-if="canReopen"
                    @click="onReopen">
                    <i class="btn-redo"></i>{{ $t('group.reopen_sub_assignment') }}
                </b-dropdown-item>
                <b-dropdown-item
                    class="btn-sub-assignment-rating"
                    v-b-modal="'portfolio-rating-sub-assignment-' + this.subAssignmentIn.id"
                    v-if="canRate">
                    <i class="btn-medal"></i>
                    {{ $t('group.rate_sub_assignment') }}
                </b-dropdown-item>
                <b-dropdown-item
                    class="btn-sub-assignment-logs"
                    v-b-modal="'sub-assignment-show-logs'">
                    <i class="btn-history"></i> {{ $t('group.sub_assignment_history') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <div
            class="error"
            v-if="error">
            <b-alert
                show
                variant="danger"
                >{{ $t('assignment.no_collaboration_partner_selected') }}
            </b-alert>
        </div>

        <design-2021-assignment-show-sub-assignment-feedback-details-model-component
            v-if="showFeedback"
            :project-id="projectId"
            :sub-assignment-in="subAssignmentIn">
        </design-2021-assignment-show-sub-assignment-feedback-details-model-component>

        <design-2021-assignment-show-sub-assignment-partner-modal-component
            v-if="
                subAssignmentIn.hasAssignmentCooperation() &&
                subAssignmentIn.assignment_cooperations[0].assignment_partners.length
            "
            :assignment-partner-in="subAssignmentIn.assignment_cooperations[0].assignment_partners[0]"
            :sub-assignment-in="subAssignmentIn"
            :project-id-in="projectId">
        </design-2021-assignment-show-sub-assignment-partner-modal-component>

        <design-2021-portfolio-show-rating-modal-component
            v-if="canRate"
            :key-name="'portfolio-rating-sub-assignment-' + this.subAssignmentIn.id"
            :rating-in="this.subAssignmentIn.portfolio_rating"
            :title="'Deelopdracht beoordeling: ' + this.subAssignmentIn.name"
            @save-rating="savePortfolioRating($event)">
        </design-2021-portfolio-show-rating-modal-component>

        <design-2021-assignment-show-sub-assignment-logs-modal-component :activities-in="getActivitiesForModal()">
        </design-2021-assignment-show-sub-assignment-logs-modal-component>
    </div>
</template>

<script>
import { ords } from '../../../../app';
import moment from 'moment';

const assignmentStatusOrds = ords.use('assignmentStatus');
const assignmentOrds = ords.use('assignment');

export default {
    name: 'design-2021-assignment-show-sub-assignment-header-component',
    //todo assignment should be put on subAssignment but doesn't seem to be working
    props: ['subAssignmentIn', 'projectId', 'assignmentStatusIn', 'group', 'selectedPageIdIn', 'viewType'],
    data() {
        return {
            deadlinePopupTitle: 'Deadline',
            bgColor: 'disabled-icon-only',
            error: false,
            projectStudent: {
                full_name: '',
            },
        };
    },
    computed: {
        badgeColor() {
            if (!this.showBadge()) {
                return '';
            }

            if (this.subAssignmentIn.getStatus().isInSubmittedState()) {
                return 'warning';
            }
            if (this.subAssignmentIn.getStatus().isInReopenedState()) {
                return 'danger';
            }
            if (this.subAssignmentIn.getStatus().isInClosedState()) {
                return 'success';
            }
        },
        badgeLabel() {
            if (!this.showBadge()) {
                return '';
            }

            if (this.subAssignmentIn.getStatus().isInSubmittedState()) {
                return 'Ingeleverd';
            }
            if (this.subAssignmentIn.getStatus().isInReopenedState()) {
                return 'Heropend';
            }
            if (this.subAssignmentIn.getStatus().isInClosedState()) {
                return 'Afgesloten';
            }
        },
        canClose() {
            if (!this.projectId) {
                return false;
            }

            if (this.$authUser.isStudent() || !this.subAssignmentIn.hasStatus()) {
                return false;
            }

            return this.subAssignmentIn.getStatus().isInSubmittedState();
        },
        canReopen() {
            if (!this.projectId) {
                return false;
            }

            if (this.$authUser.isStudent() || !this.subAssignmentIn.hasStatus()) {
                return false;
            }

            return (
                this.subAssignmentIn.getStatus().isInSubmittedState() ||
                this.subAssignmentIn.getStatus().isInClosedState()
            );
        },
        canFeedback() {
            if (!this.projectId) {
                return false;
            }

            return !this.$authUser.isStudent();
        },
        canRate() {
            if (!this.projectId) {
                return false;
            }

            // todo determine flow
            if (this.$authUser.isStudent()) {
                return false;
            }
            return this.subAssignmentIn.portfolio_rating && this.subAssignmentIn.portfolio_rating.type;
        },

        hasRatingResult() {
            if (!this.projectId) {
                return false;
            }

            if (!this.subAssignmentIn.portfolio_rating || !this.subAssignmentIn.portfolio_rating.type) {
                return false;
            }
            return this.subAssignmentIn.portfolio_rating.hasResult();
        },

        showFeedback() {
            if (!this.projectId) {
                return false;
            }

            return this.subAssignmentIn.hasFeedback() || !this.$authUser.isStudent();
        },

        getPageTitle() {
            if (this.selectedPageIdIn) {
                const activePage = this.subAssignmentIn.pages.filter((page) => page.id === this.selectedPageIdIn);
                let index = 0;

                if (activePage[0].name === null) {
                    index = this.subAssignmentIn.pages.map((page) => page.id).indexOf(activePage[0].id) + 1;
                    return `Pagina ${index}`;
                } else {
                    return activePage[0].name;
                }
            }

            return null;
        },
    },

    methods: {
        getActivitiesForModal() {
            let activities = [];
            if (this.subAssignmentIn.hasStatus() && this.subAssignmentIn.getStatus().getActivities()) {
                activities = this.subAssignmentIn.getStatus().getActivities();
            }
            return activities;
        },
        showBadge() {
            if (!this.subAssignmentIn.hasStatus()) {
                return false;
            }

            return !this.subAssignmentIn.getStatus().isInPristineSate();
        },
        onReopen() {
            this.alert.saving();

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                project_id: this.projectId,
                sub_assignment_status_id: this.subAssignmentIn.statuses[0].id,
            };

            this.axios.post(this.routes.subAssignmentStatusReopen(), data).then(
                (response) => {
                    ords.hold();

                    this.subAssignmentIn.getStatus().update(response.data.status);

                    for (let activity of response.data.status.activities) {
                        this.subAssignmentIn.getStatus().addRelation('activities', activity);
                    }
                    if (!response.data.assignment_status) {
                        ords.continue();
                        this.alert.success();
                        return;
                    }

                    if (this.assignmentStatusIn) {
                        this.assignmentStatusIn.update(response.data.assignment_status);

                        for (let activity of response.data.assignment_status.activities) {
                            this.assignmentStatusIn.addRelation('activities', activity);
                        }
                    } else {
                        assignmentStatusOrds.add(response.data.assignment_status);
                        assignmentOrds.attach(
                            this.subAssignmentIn.assignment_id,
                            'statuses',
                            response.data.assignment_status.id,
                        );

                        for (let activity of response.data.assignment_status.activities) {
                            ords.use('assignmentStatus').attach(
                                response.data.assignment_status.id,
                                'activities',
                                activity,
                            );
                        }
                    }

                    ords.continue();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onClose() {
            this.alert.saving();

            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                project_id: this.projectId,
            };

            this.axios.post(this.routes.subAssignmentStatusClose(), data).then(
                (response) => {
                    ords.hold();

                    this.subAssignmentIn.getStatus().update(response.data.status);

                    for (let activity of response.data.status.activities) {
                        this.subAssignmentIn.getStatus().addRelation('activities', activity);
                    }

                    if (!response.data.assignment_status) {
                        ords.continue();
                        this.alert.success();
                        return;
                    }

                    // todo doesn't work correctly
                    if (this.assignmentStatusIn) {
                        this.assignmentStatusIn.update(response.data.assignment_status);

                        for (let activity of response.data.assignment_status.activities) {
                            this.assignmentStatusIn.addRelation('activities', activity);
                        }
                    } else {
                        assignmentStatusOrds.add(response.data.assignment_status);
                        assignmentOrds.attach(
                            this.subAssignmentIn.assignment_id,
                            'statuses',
                            response.data.assignment_status.id,
                        );

                        for (let activity of response.data.assignment_status.activities) {
                            ords.use('assignmentStatus').attach(
                                response.data.assignment_status.id,
                                'activities',
                                activity,
                            );
                        }
                    }

                    ords.continue();

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        savePortfolioRating(values) {
            let promises = [];
            ords.hold();

            if (values.rating.value || values.rating.option_id || this.subAssignmentIn.portfolio_rating.hasResult()) {
                this.alert.saving();

                let rating_data = values.rating;

                rating_data.project_id = this.projectId;

                let promise = null;

                if (!this.subAssignmentIn.portfolio_rating.hasResult()) {
                    promise = this.axios.post(this.routes.portfolioRatingResult(), rating_data).then(
                        (response) => {
                            this.subAssignmentIn.portfolio_rating.addRelation('results', response.data);
                            // this.alert.success();
                            // this.fireClose(); todo
                            this.error = false;
                        },
                        (error) => {
                            if (error.response.data.error === 'assignmentpartner') {
                                this.error = true;
                            } else {
                                this.alert.ajaxError(error);
                                this.error = false;
                            }
                        },
                    );
                } else {
                    promise = this.axios.post(this.routes.portfolioRatingResultUpdate(), rating_data).then(
                        (response) => {
                            if (response.data) {
                                this.subAssignmentIn.portfolio_rating.getResult().update(response.data);
                            } else {
                                this.subAssignmentIn.portfolio_rating.getResult().remove();
                            }

                            // this.alert.success();
                            // if (!this.assignment.statuses || !this.assignment.statuses.length || this.assignment.statuses[0].status !== 1) {
                            //     this.fireClose();
                            // } else {
                            //     this.alert.success();
                            // } todo
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }

                if (promise) {
                    promises.push(promise);
                }
            }

            if (promises.length) {
                Promise.all(promises).then(() => {
                    ords.continue();
                    this.alert.success();
                });
            } else {
                ords.continue();
            }
        },

        getDeadlineText() {
            const currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
            const deadline = this.subAssignmentIn.deadlines[0].agenda_item.date_time;
            const daysLeft = moment(deadline).diff(moment(currentDate), 'days');

            this.bgColor =
                parseInt(daysLeft) <= 7 ? 'danger-icon' : parseInt(daysLeft) <= 14 ? 'warning-icon' : 'disabled-icon';

            if (daysLeft > 0) {
                return daysLeft > 14 ? `Verloopt over ${daysLeft} dagen.` : `Bijna verlopen nog ${daysLeft} over.`;
            } else if (daysLeft === 0) {
                const timeElapsed = moment.duration(moment(deadline).diff(moment(currentDate)));

                if (parseInt(timeElapsed.asHours()) > 0 && parseInt(timeElapsed.asHours()) >= 0) {
                    return `Bijna verlopen nog ${parseInt(timeElapsed.asHours())} uur en ${parseInt(timeElapsed.asMinutes())} minuten.`;
                } else if (parseInt(timeElapsed.asMinutes()) > 0) {
                    return `Is vandaag nog ${parseInt(timeElapsed.asMinutes())} minuten over.`;
                }
            } else {
                this.deadlinePopupTitle = 'Deadline is verlopen';
                return `Verlopen op: ${this.$options.filters.date_time_om(this.subAssignmentIn.deadlines[0].agenda_item.date_time)}`;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.assignment-header {
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: wrap;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: $grid-gutter-width;

    .left-side,
    .right-side {
        flex: 1 0 100%;
    }

    .right-side ::v-deep {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: map-get($grid-gutter-spacing, 'fifteen');

        .btn {
            width: 36px;
            height: 40px;
            font-size: 1.125rem;
            align-items: center;

            &:before,
            &:after {
                margin: 0;
            }
        }
    }

    .badge-rating {
        align-self: center;
        padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'ten');

        i {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .component-title {
        margin-bottom: 0;
        align-self: center;
        flex: 1 0 100%;
        order: 10;

        .title {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;

            .status-info {
                color: $text-muted-color;
                font-weight: $font-weight-medium;
                font-size: $base-font-size;
                margin-top: 3px;
                margin-bottom: 0;
            }
        }
    }

    .btn-comment-exclamation,
    .btn-deadline-notification {
        font-size: 24px;
        width: 36px;
        height: 40px;
    }
}

.sub-assignments-nav ::v-deep {
    .sub-assignments-context-menu {
        background-color: $primary;
        color: $white !important;
    }

    .dropdown-menu {
        border: 1px solid $border-color;

        li > a {
            font-size: $default-font-size;
        }

        .btn-approve-sub-assignment {
            i {
                color: $success;
            }
        }

        .btn-reopen-sub-assignment {
            i {
                color: $danger;
            }
        }

        .btn-sub-assignment-rating,
        .btn-sub-assignment-logs {
            i {
                color: $primary;
            }
        }
    }
}

.error {
    flex: 1 0 100%;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .assignment-header {
        .component-title {
            flex: 1 1 auto;
            order: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .assignment-header {
        justify-content: space-between;
        align-content: center;
        align-items: baseline;
        column-gap: $grid-gutter-width;

        .left-side,
        .right-side {
            flex: 1 1 auto;
        }
    }

    .assignment-header-content {
        margin-bottom: 0;
    }
}
</style>
